import { gql } from "@apollo/client";

export const RECORD_INVOICE_PAYMENT = gql`
  mutation RecordInvoicePayment($id: uuid!, $paidAmount: Int!, $paidAt: timestamptz!) {
    record_invoice_payment(id: $id, paid_amount: $paidAmount, paid_at: $paidAt) {
      invoiceId: invoice_id
      paymentId: payment_id
      paidAt: paid_at
      amountPaid: amount_paid
      isPaidInFull: is_paid_in_full
      updatedAt: updated_at
    }
  }
`;

export interface RecordInvoicePaymentData {
  record_invoice_payment: {
    invoiceId: string;
    paymentId: string;
    paidAt: string;
    amountPaid: number;
    isPaidInFull: boolean;
    updatedAt: string;
  };
}

export interface RecordInvoicePaymentVars {
  id: string;
  paidAmount: number;
  paidAt: Date;
}

export default RECORD_INVOICE_PAYMENT;
